import { useQuery } from "@tanstack/react-query";
import { unitGet } from "common/api/citajteo/dl_unit/citajteo_unit";
import { QUERY_KEYS } from "constant/react_query";
import { DlUnit } from "model/dl_unit/DlUnit";

export const useUnitGet = (
  id: string,
  searchBy: string = "id"
): DlUnit | null => {
  const { data: unit } = useQuery(
    [QUERY_KEYS.CITAJTEO_DL_UNIT_GET, id, searchBy],
    async () => {
      const result = await unitGet(id, searchBy);
      return result;
    },
    { staleTime: Infinity, enabled: id !== "" }
  );
  const result = typeof unit !== "undefined" && unit !== "" ? unit : null;
  return result;
};
